@if (existItems) {
  <div #listContainer class="languages">
    <button
      #selectedDiv
      class="languages__item"
      type="button"
      role="combobox"
      aria-controls="languages-dropdown"
      [class.languages__item--hover]="isHover || isHoverChild"
      [class.languages__item--selected]="true"
      [attr.aria-expanded]="showAll"
      [attr.aria-haspopup]="true"
      [attr.aria-label]="
        'Language selector. Current language: ' +
        (selectedItem.description || 'Unknown')
      "
      (click)="changeLanguage(selectedItem)"
      (keydown.enter)="changeLanguage(selectedItem)"
      (keydown.space)="changeLanguage(selectedItem)"
      (mouseover)="onFocus()"
      (focus)="onFocus()"
      (mouseleave)="onMouseLeave()"
      (blur)="onBlur()">
      <img
        width="24"
        height="24"
        class="languages__icon"
        role="presentation"
        [ngSrc]="'/assets/icons/' + selectedItem.id + '.png'"
        [alt]="selectedItem.description || 'Selected language icon'" />
      @if (showAll) {
        <ul
          id="languages-dropdown"
          class="languages__dropdown"
          role="listbox"
          [attr.aria-label]="'Available languages'"
          [style.top.px]="dropdownTop"
          [style.right.px]="dropdownRight"
          (mouseover)="onDropdownMouseOver()"
          (focus)="onDropdownFocus()"
          (mouseleave)="onDropdownMouseLeave()"
          (blur)="onDropdownBlur()">
          @for (dropdownItem of unselectedItems(); track dropdownItem) {
            <li
              class="languages__dropdown-item"
              role="option"
              tabindex="0"
              [class.languages__dropdown-item--selected]="dropdownItem.selected"
              [attr.aria-selected]="dropdownItem.selected"
              (click)="changeLanguage(dropdownItem)"
              (keydown.enter)="changeLanguage(dropdownItem)"
              (keydown.space)="changeLanguage(dropdownItem)">
              <img
                width="24"
                height="24"
                class="languages__icon"
                role="presentation"
                [ngSrc]="'/assets/icons/' + dropdownItem.id + '.png'"
                [alt]="dropdownItem.description || 'Language icon'" />
              <span>{{ dropdownItem.description }}</span>
            </li>
          }
        </ul>
      }
    </button>
  </div>
}
